import Vue from "vue";

export const confirm = (
  message = "",
  title = "",
  okeTitle = "",
  cancelTitle = "",
  okVariant = "danger"
) => {
  const vm = new Vue({});
  return vm.$bvModal
    .msgBoxConfirm(message, {
      modalClass: "c-confirm-box-modal",
      dialogClass: "c-confirm-box-dialog",
      okOnly: true,
      title: title,
      cancelDisabled: true,
      size: "sm",
      buttonSize: "sm",
      okVariant: okVariant,
      okTitle: okeTitle,
      headerClass: "p-2 pl-3",
      footerClass: "p-2 border-top-0",
      hideHeaderClose: false,
      centered: true,
      cancelTitle: cancelTitle
    })
    .then(value => value)
    .catch(err => err);
};

export const toast = (
  message,
  title = null,
  autoHideDelay = 2000,
  toaster = "b-toaster-top-center",
  variant = "primary"
) => {
  const vm = new Vue({});
  return vm.$bvToast.toast(message, {
    title,
    noCloseButton: false,
    autoHideDelay,
    appendToast: true,
    toaster,
    variant,
    noFade: false,
    solid: true
  });
};

export const formatNumber = (number) => {
  return Math.round(number * 100) / 100;
}
